function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import cn from 'classnames';
import indexOf from 'lodash/indexOf';
import isObjectLike from 'lodash/isObjectLike';
import toNumber from 'lodash/toNumber';
import intlShape from 'shapes/intlShape';
import Eye from 'svg/eye.svg';
import EyeOff from 'svg/eye-off.svg';
var _React_PureComponent;
/**
 * Input component extends simple input
 *
 * @param {string} id - unique input id
 * @param {string} [type="text"] - input type
 * @param {string} [value=""] - input value
 * @param {(string|Object)} [className] - additional input className
 * @param {boolean} [hasError=false] - indicates if input has form errors
 * @param {boolean} [isDisabled=false] - disable input
 * @param {Object} [attributes] - additional input attributes
 * @param {function} onChange - action that is triggered by input value change
 * @param {function} [onBlur] - action that is triggered when input has been lost focus
 */ class Input extends (_React_PureComponent = React.PureComponent) {
    get isPasswordType() {
        return this.props.type === 'password';
    }
    getValue(evt) {
        if (indexOf([
            'checkbox',
            'radio'
        ], this.props.type) !== -1 && !evt.target.checked) {
            return '';
        }
        if (this.props.type === 'number' && evt.target.value) {
            return toNumber(evt.target.value);
        }
        return evt.target.value;
    }
    renderPlaceholder() {
        if (!this.props.placeholder) {
            return null;
        }
        return isObjectLike(this.props.placeholder) ? this.props.intl.formatMessage(this.props.placeholder, _object_spread({}, this.props.placeholder.values)) : this.props.placeholder;
    }
    renderShowHidePassword() {
        const { showPassword } = this.state;
        if (!this.isPasswordType) return null;
        if (showPassword) return /*#__PURE__*/ _jsx(Eye, {
            onClick: ()=>this.setState({
                    showPassword: false
                })
        });
        return /*#__PURE__*/ _jsx(EyeOff, {
            onClick: ()=>this.setState({
                    showPassword: true
                })
        });
    }
    render() {
        const { showPassword } = this.state;
        let { type } = this.props;
        if (this.isPasswordType && showPassword) {
            type = 'text';
        }
        return /*#__PURE__*/ _jsxs("div", {
            className: cn('input-container', this.props.classNameWrapper),
            children: [
                /*#__PURE__*/ _jsx("input", _object_spread_props(_object_spread({
                    id: this.props.id,
                    type: type,
                    value: this.props.value,
                    autoComplete: this.isPasswordType ? 'off' : 'on',
                    className: cn({
                        'form-control': this.props.type !== 'checkbox' && this.props.type !== 'radio',
                        'border-danger': this.props.hasError
                    }, this.props.className),
                    disabled: this.props.isDisabled
                }, this.props.attributes), {
                    placeholder: this.renderPlaceholder(),
                    onChange: (evt)=>this.props.onChange({
                            id: this.props.id,
                            value: this.getValue(evt)
                        }),
                    onBlur: (evt)=>this.props.onBlur({
                            id: this.props.id,
                            value: this.getValue(evt)
                        }),
                    onFocus: (evt)=>this.props.onFocus({
                            id: this.props.id,
                            value: this.getValue(evt)
                        })
                })),
                this.renderShowHidePassword()
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = {
            showPassword: false
        };
    }
}
_define_property(Input, "propTypes", {
    // Explicit props
    id: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    classNameWrapper: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    placeholder: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    hasError: PropTypes.bool,
    isDisabled: PropTypes.bool,
    attributes: PropTypes.object,
    // Implicit props
    intl: intlShape.isRequired,
    // Explicit Actions
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func
});
_define_property(Input, "defaultProps", {
    type: 'text',
    value: '',
    className: '',
    hasError: false,
    isDisabled: false,
    attributes: {},
    onBlur: ()=>{},
    onFocus: ()=>{}
});
export default injectIntl(Input);
